module.exports = __webpack_public_path__ + "img/sticker_shipped.36de281f.png";